import { RootState } from '..';
import { jobCardAdapter, jobCarReportAdapter } from './adapter';

export const jobCardsRunningSelector = jobCardAdapter.getSelectors((state: RootState) => state.jobCard.jobCardsRunning);
export const jobCardsNotRunningSelector = jobCardAdapter.getSelectors(
  (state: RootState) => state.jobCard.jobCardsNotRunning,
);
export const jobCardsIsLoadingCreateReportSelector = (state: RootState) => state.jobCard.isLoadingCreateReport;
export const jobCardsNotRunningLoadingSelector = (state: RootState) => state.jobCard.jobCardsNotRunning.loading;
export const jobCardsRunningLoadingSelector = (state: RootState) => state.jobCard.jobCardsRunning.loading;
export const jobCardsNotRunningAllSelector = (state: RootState) => state.jobCard.jobCardsNotRunning.pagination.all;
export const jobCardsRunningAllSelector = (state: RootState) => state.jobCard.jobCardsRunning.pagination.all;
export const jobCardsNotRunningPageSelector = (state: RootState) => state.jobCard.jobCardsNotRunning.pagination.page;
export const jobCardsRunningPageSelector = (state: RootState) => state.jobCard.jobCardsRunning.pagination.page;
export const jobCardsIsShowReportSavedModal = (state: RootState) => state.jobCard.showReportSavedModal;
export const jobCardsIsAddedReportWithEndTime = (state: RootState) => state.jobCard.isAddedReportWithEndTime;
export const jobCardsIsNeedAutoStartStop = (state: RootState) => state.jobCard.isNeedAutoStartStop;
export const jobCardIsSearching = (state: RootState) => state.jobCard.isSearching;
export const jobCardsRecentlySelector = jobCardAdapter.getSelectors(
  (state: RootState) => state.jobCard.jobCardsRecently,
);
export const jobCardsRecentlyAllSelector = (state: RootState) => state.jobCard.jobCardsRecently.pagination.all;
export const jobCardsRecentlyPageSelector = (state: RootState) => state.jobCard.jobCardsRecently.pagination.page;
export const jobCardsRecentlyLoadingSelector = (state: RootState) => state.jobCard.jobCardsRecently.loading;

export const jobCardReportsSelector = jobCarReportAdapter.getSelectors(
  (state: RootState) => state.jobCard.jobCardReports,
);

export const selectedJobCardTimeReports = (state: RootState) => state.jobCard.selectedJobCard?.Reports;
